module.exports = __webpack_public_path__ + "img/login-logo.3e04baa4.png";